import MembershipOffersComponent from 'components/membershipOffers';

const Membership = () => {
  return <MembershipOffersComponent isSettingsFromPortal={true} />;
};

export default Membership;
